import { generationErrorCopy } from './generationCopy';
export function GenerationReadError({ error, retry, pending, label }: { error: unknown; retry: () => void; pending: boolean; label: string }) {
  return <div className="admin-message admin-message_error" role="alert"><p>{generationErrorCopy(error)}</p><button className="workspace-secondary-button" type="button" disabled={pending} onClick={retry}>{label}</button></div>;
}
